/**
 * Created by sasik on 12/7/15.
 */

/**
 * drag and drop for MenuController
 */
$(function  () {

    var adjustment;
    var el=null;
    var el2=null;
    var el3=null;

    $(".menu-drag-drop").sortable({
      /*  group: 'menu-drag-drop',*/
        /*pullPlaceholder: true,*/
        handle: ".drag",
        //placeholder:"list-group-item media super-menu-drag higlight",
        // animation on drop
        onDrop: function  ($item, container, _super) {
            var $clonedItem = $('<li class="placeholder"/>');//.css({height: 0});
            $item.before($clonedItem);

            $clonedItem.animate({'opacity': 0});

            $item.animate($clonedItem.position(), function  () {
                $clonedItem.detach();
                _super($item, container);
            });
        },

        // set $item relative to cursor position
        onDragStart: function ($item, container, _super) {
            var offset = $item.offset(),
                pointer = container.rootGroup.pointer;

            adjustment = pointer.top-offset.top;
            _super($item, container);
        },
        onDrag: function ($item, position,_super) {
            position.left=0;
            position.top-=adjustment;
            /*$item.css({
                left: 0,
                top: position.top - adjustment.top
            });*/
            _super($item,position);
        }
    });

});

